/* =============================
Arknights: Endfield Catalog
Auto-generated from config
Pattern: unified
============================= */
(function () {
const API_SOURCES = {
'naonao': {
name: 'ns',
enabled: true,
priority: 1,
idPrefix: 'NAO',
prefixes: [],
unwanted: new Set(['亚服','欧美','男角色','女角色']),
nameKey: 'name',
idKey: 'id',
imageKey: 'img',
root: 'results'
}
};

const NAONAO_BASE = `https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/ake-multi-proxy?source=naonao`;
let selected = {};
let allSearchResults = [];
let renderedCount = 0;
const BATCH_SIZE = 24;
let resultObserver = null;

const initResultObserver = () => {
if (resultObserver) resultObserver.disconnect();
resultObserver = new IntersectionObserver((entries) => {
if (entries[0].isIntersecting && renderedCount < allSearchResults.length) { renderBatch(); } }, { rootMargin: '200px'
    }); }; const updateSelectedUI=()=> {
    const totalCount = Object.values(selected).reduce((sum, sel) => sum + (sel.count || 0), 0);
    const el = document.querySelector("#selectedCount");
    if (el) el.textContent = totalCount;
    };

    const scrollToResults = () => {
    document.querySelector("#results")?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const showToast = () => {
    const toast = document.querySelector("#toast");
    if (!toast) return;
    toast.classList.remove('hidden', 'show');
    toast.offsetHeight;
    toast.classList.add('show');
    setTimeout(() => { toast.classList.remove('show'); setTimeout(() => toast.classList.add('hidden'), 300); }, 3000);
    };

    const copyToClipboard = text => {
    if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(showToast).catch(() => fallbackCopy(text));
    } else fallbackCopy(text);
    };

    const fallbackCopy = text => {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;left:-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); showToast(); } catch (e) { }
    document.body.removeChild(ta);
    };

    const escapeHtml = s => String(s || '').replace(/[&<>"]|'/g, m => ({
        '&': '&amp;', '<': '&lt;' , '>' : '&gt;' , '"' : '&quot;' , "'" : '&#39;' }[m])); let appSettings={
            translations_json: '{}' , images_json: '{}' , api_toggles: {}, api_priority: {} }; const logger={ log:
            (...args)=> { if (appSettings.enable_debug || window.location.search.includes('debug=1'))
            console.log(...args); },
            warn: (...args) => { if (appSettings.enable_debug || window.location.search.includes('debug=1'))
            console.warn(...args); },
            error: (...args) => { console.error(...args); }
            };

            let nameTranslationsMap = {};
            let customImagesMap = {};

            const translateName = name => nameTranslationsMap[name] || name;
            const getCustomImage = name => customImagesMap[name] || null;

            const loadSettings = () => {
            try {
            const el = document.getElementById('catalog-settings-naonao-v1');
            if (el) {
            const parsed = JSON.parse(el.textContent);
            appSettings = { ...appSettings, ...parsed };
            logger.log('✅ [Naonao-Init] Loaded settings from DOM:', appSettings);
            } else {
            console.warn('⚠️ [Naonao-Init] Settings element not found: catalog-settings-naonao-v1');
            }

            // Apply API Settings
            if (appSettings.api_toggles) {
            Object.keys(API_SOURCES).forEach(apiId => {
            if (appSettings.api_toggles.hasOwnProperty(apiId)) API_SOURCES[apiId].enabled =
            appSettings.api_toggles[apiId] === true;
            if (appSettings.api_names && appSettings.api_names[apiId]) API_SOURCES[apiId].name =
            appSettings.api_names[apiId];
            if (appSettings.api_priority && appSettings.api_priority.hasOwnProperty(apiId)) API_SOURCES[apiId].priority
            = parseInt(appSettings.api_priority[apiId], 10);
            });
            }

            // Load Translations
            try {
            const json = JSON.parse(appSettings.translations_json || '{}');
            Object.entries(json).forEach(([key, val]) => {
            const standardValue = typeof val === 'string' ? val.trim() : val;
            key.split('|').forEach(k => { if (k.trim()) nameTranslationsMap[k.trim()] = standardValue; });
            });
            logger.log('🔍 [Naonao-Init] Translations loaded:', Object.keys(nameTranslationsMap).length);
            } catch (e) { logger.error('Error parsing translations:', e); }

            // Load Images
            try {
            const json = JSON.parse(appSettings.images_json || '{}');
            Object.entries(json).forEach(([key, val]) => {
            const imageUrl = typeof val === 'string' ? val.trim() : val;
            key.split('|').forEach(k => { if (k.trim()) customImagesMap[k.trim()] = imageUrl; });
            });
            } catch (e) { }

            } catch (e) { console.error('Error loading settings:', e); }
            };

            function privateToPublicID(privateID, source) {
            if (!privateID) return '';
            const srcConf = API_SOURCES[source];
            const prefix = srcConf?.name ? srcConf.name.replace(/\s+/g, '') : 'ACC';
            let cleanId = String(privateID).replace(/Account\s*/gi, '').replace(/Guest\s*/gi, '').trim();
            return GachaUtils.obfuscateId(cleanId, prefix);
            } function publicToPrivateID(publicID) {
                if (!publicID) return '' ; let core=publicID.trim(); if (core.includes('----')) {
                core=core.split('----')[0]; } if (core.includes('-')) { core=core.split('-')[1]; } else if (core.length>
                5 && (core.startsWith('WW') || core.length > 12)) {
                if (core.length >= 5) core = core.substring(2, core.length - 2);
                }
                let chars = core.split('');
                for (let i = 0; i + 1 < chars.length; i +=2) { const t=chars[i]; chars[i]=chars[i + 1]; chars[i + 1]=t;
                    } return chars.reverse().join(''); } const normalizeString=(name, prefixes)=> {
                    if (!name) return '';
                    let n = String(name).trim();
                    if (prefixes) prefixes.forEach(p => { if (n.startsWith(p)) n = n.slice(p.length); });
                    return n;
                    };

                    const getResultsArray = (payload, apiId) => {
                    if (!payload) return [];
                    if (Array.isArray(payload)) return payload;
                    const config = API_SOURCES[apiId];
                    if (config && config.root) {
                    const parts = config.root.split('.');
                    let cur = payload;
                    for (const p of parts) { if (cur) cur = cur[p]; }
                    if (Array.isArray(cur)) return cur;
                    }
                    return payload.results || payload.items || payload.data?.items || payload.data ||
                    (Array.isArray(payload.c) ? payload.c : []);
                    };

                    const updateThumbDisplay = (thumb, key) => {
                    const count = selected[key]?.count || 0;
                    const existingBadge = thumb.querySelector('.count-badge');
                    if (count > 0) {
                    thumb.classList.add('selected');
                    if (existingBadge) existingBadge.textContent = count;
                    else {
                    const b = document.createElement('div');
                    b.className = 'count-badge';
                    b.textContent = count;
                    thumb.querySelector('.thumb-img-container').appendChild(b);
                    }
                    } else {
                    thumb.classList.remove('selected');
                    if (existingBadge) existingBadge.remove();
                    }
                    };

                    const loadResources = () => {
                    logger.log('🚀 Loading...');
                    const resourcePromises = [];
                    if (API_SOURCES['naonao'].enabled) {
                    const url = NAONAO_BASE + (NAONAO_BASE.includes('?') ? '&' : '?') + 'action=' + encodeURIComponent("list") + '&'.slice(0,-1);
                    resourcePromises.push(fetch(url).then(r => r.json()).catch(err => {
                    logger.warn('⚠️ fetch failed:', err);
                    return null;
                    }));
                    }

                    Promise.all(resourcePromises).then(results => {
                    let resultIdx = 0;
                    const apiData = {};
                    {
                    const raw = results[resultIdx++];
                    const dataArray = getResultsArray(raw, 'naonao');
                    apiData['naonao'] = Array.isArray(dataArray) ? dataArray : [];
                    const sMap = {};
                    sMap['Asia'] = 'A01';
                    sMap['Global'] = 'A02';
                    window._naonaoServerMap = sMap;
                    }

                    const merged = {};
                    if (apiData['naonao'] && apiData['naonao'].length > 0) {
                    const prefixes = [];
                    const unwanted = new Set(['亚服','欧美','男角色','女角色']);
                    apiData['naonao'].forEach(item => {
                    const rawName = item.name || item.name;
                    const norm = normalizeString(rawName, prefixes);
                    if (unwanted.has(norm)) return;
                    const displayLabel = translateName(norm);
                    let itemImg = item.img || item.img_url || item.role_img || item.card_img;
                    if (!merged[displayLabel]) {
                    merged[displayLabel] = { displayLabel: displayLabel, normName: norm, rawNames: new Set([rawName,
                    norm, displayLabel]), _naonao_id: String(item.id || item.id), img: itemImg };
                    } else {
                    merged[displayLabel]._naonao_id = String(item.id || item.id);
                    if(!merged[displayLabel].img) merged[displayLabel].img = itemImg;
                    merged[displayLabel].rawNames.add(rawName);
                    merged[displayLabel].rawNames.add(norm);
                    }
                    });
                    }

                    let allItems = Object.values(merged);
                    const orderSource = appSettings.character_order_source;
                    if (orderSource && apiData[orderSource]) {
                    const orderMap = new Map();
                    const refItems = apiData[orderSource];
                    const prefixes = API_SOURCES[orderSource].prefixes || [];
                    const nKey = API_SOURCES[orderSource].nameKey || 'name';
                    let rank = 0;
                    refItems.forEach(item => {
                    const raw = item[nKey] || item.name;
                    if (!raw) return;
                    const norm = normalizeString(raw, prefixes);
                    const std = translateName(norm);
                    if (!orderMap.has(std)) orderMap.set(std, rank++);
                    });
                    allItems.sort((a, b) => {
                    const rankA = orderMap.has(a.displayLabel) ? orderMap.get(a.displayLabel) : 10000;
                    const rankB = orderMap.has(b.displayLabel) ? orderMap.get(b.displayLabel) : 10000;
                    if (rankA !== rankB) return rankA - rankB;
                    return a.displayLabel.localeCompare(b.displayLabel);
                    });
                    }
                    window._characterImageMap = {};
                    allItems.forEach(it => { if (it.img) window._characterImageMap[it.displayLabel] = it.img; });
                    renderFilters(allItems);
                    }).catch(e => {
                    console.error('❌ Error:', e);
                    document.querySelector("#filters").innerHTML = `Error loading characters.`;
                    });
                    };

                    const renderFilters = (items) => {
                    const container = document.querySelector("#filters");
                    if (!container) return;
                    container.innerHTML = ``;
                    items.forEach(it => {
                    const thumb = document.createElement('div');
                    const displayLabel = it.displayLabel;
                    let imgSrc = getCustomImage(it.normName) || getCustomImage(it.displayLabel);
                    if (!imgSrc) { for (let r of it.rawNames) { imgSrc = getCustomImage(r); if (imgSrc) break; } }
                    const finalImg = imgSrc || it.img;
                    thumb.className = `thumb`;
                    thumb.dataset.naonaoId = it._naonao_id || '';
                    thumb.dataset.displayLabel = displayLabel;
                    thumb.innerHTML = `<div class="thumb-img-container"><img alt="${displayLabel}"
                            src="${finalImg || ''}" loading="lazy" /></div>
                    <div class="label">${displayLabel}</div>`;
                    thumb.onclick = () => {
                    const key = thumb.dataset.displayLabel;
                    if (selected[key]) { selected[key].count++; } else {
                    selected[key] = {
                    count: 1,
                    naonaoId: thumb.dataset.naonaoId,
                    rawNames: Array.from(it.rawNames)
                    };
                    }
                    updateThumbDisplay(thumb, key);
                    updateSelectedUI();
                    };
                    container.appendChild(thumb);
                    });
                    };

                    const performSearch = () => {
                    const selectedKeys = Object.keys(selected).filter(k => selected[k].count > 0);
                    if (!selectedKeys.length) return alert("Select characters first.");
                    const res = document.querySelector("#results");
                    res.innerHTML = `<div class="no-data">Searching...</div>`;
                    scrollToResults();
                    const serverSelect = document.querySelector("#serverSelect");
                    const server = serverSelect ? serverSelect.value : '';
                    const promises = [];

                    if (API_SOURCES['naonao'].enabled) {

                                let c = [];
                                selectedKeys.forEach(k => { if(selected[k].naonaoId) { for (let i = 0; i <
                                    selected[k].count; i++) c.push(selected[k].naonaoId); } }); const
                                    sid=window._naonaoServerMap?.[server] || '' ; if (server && sid) c=[sid, ...c];
                                    const url=NAONAO_BASE + (NAONAO_BASE.includes('?') ? '&' : '?' )
                                    + 'key=' + encodeURIComponent(c.join(',')); promises.push(fetch(url).then(r=>
                                    r.json()).catch(() => ({ results: [] })));
                                    
                                    } else promises.push(Promise.resolve({ results: [] }));

                                    Promise.all(promises).then(responses => {
                                    const payload = {}; payload.naonao = responses[0];
                                    if (payload.naonao) {
                                    let items = getResultsArray(payload.naonao, 'naonao');
                                    items = items.filter(acc => {
                                    let has = {};
                                    if (acc.deck_info) { try { has = typeof acc.deck_info === 'string' ?
                                    JSON.parse(acc.deck_info) : acc.deck_info; } catch(e){} }
                                    else if (acc.items) { acc.items.forEach(it => { has[it.name] = (has[it.name] || 0) +
                                    (it.count || 1); }); }
                                    return selectedKeys.every(k => { return selected[k].rawNames.some(rn => (has[rn] ||
                                    0) >= selected[k].count); });
                                    });
                                    payload.naonao = { results: items };
                                    }
                                    renderResults(payload);
                                    }).catch(e => { console.error(e); res.innerHTML = `Search failed.`; });
                                    };

                                    const calculateAccountTotal = (item) => {
                                    let total = 0;
                                    const apiConf = API_SOURCES[item._src];
                                    if (!apiConf) return 0;
                                    let has = {};
                                    if (item.deck_info) { try { has = typeof item.deck_info === 'string' ?
                                    JSON.parse(item.deck_info) : item.deck_info; } catch (e) { } }
                                    else if (item.items) { item.items.forEach(it => { has[it.name] = (has[it.name] || 0)
                                    + (it.count || 1); }); }
                                    const prefixes = apiConf.prefixes;
                                    const unwanted = apiConf.unwanted;
                                    Object.entries(has).forEach(([name, count]) => {
                                    const norm = normalizeString(name, prefixes);
                                    if (!unwanted.has(norm)) { total += (parseInt(count) || 0); }
                                    });
                                    return total;
                                    };

                                    const sortResults = () => {
                                    const sortMode = document.getElementById('sortSelect')?.value || 'default';
                                    if (sortMode === 'default') { allSearchResults.sort((a, b) => (a._p || 0) - (b._p ||
                                    0)); }
                                    else {
                                    allSearchResults.sort((a, b) => {
                                    const totalA = calculateAccountTotal(a);
                                    const totalB = calculateAccountTotal(b);
                                    if (sortMode === 'count_desc') return totalB - totalA;
                                    if (sortMode === 'count_asc') return totalA - totalB;
                                    return 0;
                                    });
                                    }
                                    renderedCount = 0;
                                    document.querySelector("#results").innerHTML = ``;
                                    renderBatch();
                                    };

                                    const renderResults = payload => {
                                    const res = document.querySelector("#results");
                                    let list = [];
                                    if (payload.naonao) {
                                    const rawItems = getResultsArray(payload.naonao, 'naonao');
                                    const l = rawItems.map(a => ({ ...a, _src: 'naonao', _p:
                                    API_SOURCES['naonao'].priority }));
                                    list = list.concat(l);
                                    }
                                    if (!list.length) return res.innerHTML = `<div class="no-data">No results found.
                                    </div>`;
                                    res.innerHTML = ``;
                                    allSearchResults = list;
                                    renderedCount = 0;

                                    // Apply Initial Sort based on dropdown or default to count_desc
                                    const sortMode = document.getElementById('sortSelect')?.value || 'count_desc';
                                    if (sortMode === 'default') {
                                    allSearchResults.sort((a, b) => (a._p || 0) - (b._p || 0));
                                    } else {
                                    allSearchResults.sort((a, b) => {
                                    const totalA = calculateAccountTotal(a);
                                    const totalB = calculateAccountTotal(b);
                                    if (sortMode === 'count_desc') return totalB - totalA;
                                    if (sortMode === 'count_asc') return totalA - totalB;
                                    return 0;
                                    });
                                    }

                                    initResultObserver();
                                    renderBatch();
                                    };

                                    const renderBatch = () => {
                                    const res = document.querySelector("#results");
                                    const sentinel = document.getElementById('sentinel');
                                    if (sentinel) sentinel.remove();
                                    const batch = allSearchResults.slice(renderedCount, renderedCount + BATCH_SIZE);
                                    if (!batch.length) return;
                                    batch.forEach(a => {
                                    const apiConf = API_SOURCES[a._src];
                                    let items = Array.isArray(a.items) ? a.items : [];
                                    if (!items.length && a.deck_info) {
                                    try {
                                    const di = typeof a.deck_info === 'string' ? JSON.parse(a.deck_info) : a.deck_info;
                                    items = Object.entries(di || {}).map(([name, count]) => ({ name, count }));
                                    } catch(e){}
                                    }
                                    const card = document.createElement('div');
                                    card.className = `result-card`;
                                    const rawId = a.code || a.account_id || a.name || a.id || "";
                                    const displayId = privateToPublicID(rawId, a._src);
                                    let info = [];
                                    let serverName = 'Unknown';
                                    const di = a.deck_info ? (typeof a.deck_info === 'string' ? JSON.parse(a.deck_info)
                                    : a.deck_info) : {};
                                    Object.keys(di || {}).forEach(k => {
                                    const normK = normalizeString(k, apiConf.prefixes);
                                    if(['America', 'Europe', 'Asia', 'SEA', 'HMT'].includes(normK)) serverName = normK;
                                    // Map Chinese server names
                                    if(normK === '欧美') serverName = 'Global';
                                    if(normK === '亚服' || normK === '日服' || normK === '韩服') serverName = 'Asia';
                                    if(normK === '台服') serverName = 'HMT';

                                    if(k.includes('女')) info.push(`Gender: Female`);
                                    if(k.includes('男')) info.push(`Gender: Male`);
                                    });
                                    const src = a.source || '';
                                    const lm = src.match(/等级[:：]([0-9]+)/);
                                    if(lm) info.push(`Level: ${lm[1]}`);
                                    if(serverName !== 'Unknown') info.push(`Server: ${serverName}`);
                                    if (!appSettings.hide_source) info.push(`Source: ${API_SOURCES[a._src].name}`);
                                    const charData = items.filter(c => {
                                    const n = normalizeString(c.name, apiConf.prefixes);
                                    if (c.id && (String(c.id).startsWith('A') || String(c.id).startsWith('13'))) return
                                    false;
                                    if (['Gender', 'Server', 'Email', 'Level', '性别', '区服'].some(ignore =>
                                    n.includes(ignore))) return false;
                                    return !apiConf.unwanted.has(n);
                                    }).map(c => {
                                    const std = translateName(normalizeString(c.name, apiConf.prefixes));
                                    const img = getCustomImage(std) || c.img_url || c.role_img ||
                                    window._characterImageMap?.[std] || '';
                                    return {
                                    html: `<div class="char"><img src="${img}" alt="${std}"
                                            onerror="this.style.opacity=.5" />
                                        <div class="cname">${std}</div>${c.count > 1 ? '<div class="char-count">x' +
                                            c.count + '</div>' : ''}
                                    </div>`,
                                    name: std
                                    };
                                    });
                                    const charString = charData.map(c => c.name).join(',');
                                    const extendedId = `${displayId}----${serverName}----[${charString}]`;
                                    card.innerHTML = `<div class="result-header">
                                        <div>Account ID: <strong>${escapeHtml(displayId)}</strong></div>
                                        <div class="header-btns">
                                            <button class="copy-btn">Copy ID</button>
                                            <button class="price-btn">Price Check</button>
                                        </div>
                                    </div>
                                    <div class="result-info">${info.join(' | ')}</div>
                                    <div class="chars-row">${charData.map(c => c.html).join('')}</div>`;
                                    card.querySelector('.copy-btn').onclick = () => window.copyToClipboard(extendedId);
                                    card.querySelector('.price-btn').onclick = () => window.showPriceCheck(displayId,
                                    extendedId);
                                    res.appendChild(card);
                                    });
                                    renderedCount += batch.length;
                                    if (renderedCount < allSearchResults.length) { const
                                        s=document.createElement('div'); s.id=`sentinel`; s.style.height=`50px`;
                                        s.innerHTML=`<div
                                        style="text-align:center; padding: 10px; color: var(--text-muted);">Loading...
                                        </div>`;
                                        res.appendChild(s);
                                        resultObserver.observe(s);
                                        }
                                        };

                                        const initPriceModal = () => {
                                        const modal = document.createElement('div');
                                        modal.id = `priceCheckModal`;
                                        modal.className = `modal-backdrop hidden`;
                                        modal.innerHTML = `
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h3>Price Check Inquiry</h3>
                                                <button class="close-modal">&times;</button>
                                            </div>
                                            <div class="modal-body">
                                                <p class="step-header">Step 1: Copy Account ID</p>
                                                <div class="id-display-box highlighted">
                                                    <span>Account ID:</span>
                                                    <code id="modalAccountId">---</code>
                                                    <input type="hidden" id="modalFullId" value="">
                                                    <button class="copy-mini-btn" id="modalCopyBtn">Copy</button>
                                                </div>

                                                <div class="modal-divider"></div>

                                                <p class="step-header">Step 2: Choose Contact Method For Price Quotation
                                                </p>

                                                <div class="contact-row">
                                                    <div class="contact-option primary">
                                                        <div class="opt-icon">✨</div>
                                                        <div class="opt-details">
                                                            <strong>Direct Message</strong>
                                                            <a href="https://discord.com/users/477359052662243349"
                                                                target="_blank" class="modal-btn">DM Admin</a>
                                                        </div>
                                                    </div>

                                                    <div class="contact-option secondary">
                                                        <div class="opt-icon">🌸</div>
                                                        <div class="opt-details">
                                                            <strong>Join Server</strong>
                                                            <a href="https://discord.invite/exvg8GR8sk" target="_blank"
                                                                class="modal-btn">Join & DM CL</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p class="modal-hint"
                                                    style="text-align:center; margin-top:8px; font-size:0.8em; color:var(--text-muted); opacity:0.8;">
                                                    (Discord Tag: <code>gachamacha2025</code>)
                                                </p>
                                            </div>
                                        </div>`;
                                        document.body.appendChild(modal);
                                        modal.querySelector('.close-modal').onclick = () =>
                                        modal.classList.add('hidden');
                                        modal.onclick = (e) => { if (e.target === modal) modal.classList.add('hidden');
                                        }; modal.querySelector('#modalCopyBtn').onclick=()=> {
                                        const fullId = document.querySelector('#modalFullId').value;
                                        copyToClipboard(fullId);
                                        const btn = document.querySelector('#modalCopyBtn');
                                        btn.textContent = 'Copied!';
                                        setTimeout(() => btn.textContent = 'Copy', 2000);
                                        };
                                        };

                                        window.showPriceCheck = (id, fullId) => {
                                        const modal = document.querySelector("#priceCheckModal");
                                        if (!modal) return;
                                        document.querySelector("#modalAccountId").textContent = id;
                                        document.querySelector("#modalFullId").value = fullId || id;
                                        modal.classList.remove('hidden');
                                        };


                                        const sortSel = document.querySelector("#sortSelect");
                                        if (sortSel) sortSel.onchange = sortResults;

                                        document.querySelector("#searchBtn").onclick = performSearch;
                                        document.querySelector("#clearBtn").onclick = () => {
                                        selected = {};
                                        document.querySelectorAll('.thumb').forEach(t => {
                                        t.classList.remove('selected'); t.querySelector('.count-badge')?.remove(); });
                                        updateSelectedUI();
                                        document.querySelector("#results").innerHTML = ``;
                                        };

                                        window.copyToClipboard = copyToClipboard;
                                        initPriceModal();

                                        const startup = () => {
                                        logger.log('🚀 [Naonao-Startup] DOM Ready or Already Loaded');
                                        loadSettings();
                                        loadResources();
                                        };

                                        if (document.readyState === 'loading') {
                                        document.addEventListener('DOMContentLoaded', startup);
                                        } else {
                                        startup();
                                        }
                                        })();